<template>
  <div class="app-container">
    <dida-module-header
      title="酒店资源发布控制"
      description="统一管理酒店上架、静态资源和 ARI 发布，查看道旅受理时间、批次任务与单酒店诊断证据。"
      :status="listError ? 'danger' : 'healthy'"
      :status-text="listError || '资源发布通道可观测'"
      :updated-at="lastRefreshedAt"
      auto-refresh-text="每 10 秒自动刷新"
      :loading="listLoading"
      @refresh="getList"
    />
    <div class="filter-container">
      <el-select v-model="listQuery.supplier" class="filter-item" clearable placeholder="资源类型" size="small" style="width: 150px">
        <el-option v-for="item in suppliers" :key="item.value" :label="item.label" :value="item.value" />
      </el-select>
      <el-select v-model="listQuery.ari_sort" class="filter-item" size="small" style="width: 170px" @change="handleFilter">
        <el-option label="ARI受理时间倒序" value="desc" />
        <el-option label="ARI受理时间正序" value="asc" />
      </el-select>
      <el-select v-model="listQuery.ari_health" class="filter-item" clearable placeholder="ARI受理状态" size="small" style="width: 150px">
        <el-option label="最近30分钟有受理" value="recent" />
        <el-option label="超过30分钟或未受理" value="stale" />
        <el-option label="从未受理" value="never" />
      </el-select>
      <el-select v-model="listQuery.rate_category" class="filter-item" clearable placeholder="价格分类" size="small" style="width: 140px">
        <el-option label="有协议价" value="protocol" />
        <el-option label="有活动价" value="activity" />
        <el-option label="有待分类价格" value="unclassified" />
      </el-select>
      <el-select v-model="listQuery.rate_publish_status" class="filter-item" clearable placeholder="价格推送结果" size="small" style="width: 155px">
        <el-option label="已有成功推送" value="success" />
        <el-option label="尚无成功推送" value="not_success" />
      </el-select>
      <el-input v-model="listQuery.source_hotel_code" class="filter-item" clearable placeholder="源酒店编码" size="small" style="width: 190px" />
      <el-input v-model="listQuery.dida_hotel_code" class="filter-item" clearable placeholder="Dida酒店码" size="small" style="width: 170px" />
      <el-input v-model="listQuery.hotel_name" class="filter-item" clearable placeholder="酒店名称" size="small" style="width: 220px" />
      <el-select v-model="listQuery.desired_status" class="filter-item" clearable placeholder="目标状态" size="small" style="width: 130px">
        <el-option label="上架" :value="1" />
        <el-option label="下架" :value="0" />
      </el-select>
      <el-select v-model="listQuery.bulk_operation_locked" class="filter-item" clearable placeholder="一键保护" size="small" style="width: 130px">
        <el-option label="已锁定" :value="1" />
        <el-option label="未锁定" :value="0" />
      </el-select>
      <el-select v-model="listQuery.source_status" class="filter-item" clearable placeholder="源状态" size="small" style="width: 130px">
        <el-option label="源可售" :value="1" />
        <el-option label="源不可售" :value="0" />
      </el-select>
      <el-select v-model="listQuery.foreign_guest_status" class="filter-item" clearable placeholder="外宾接待" size="small" style="width: 145px">
        <el-option label="支持外宾" value="supported" />
        <el-option label="不支持外宾" value="unsupported" />
        <el-option label="外宾状态未知" value="unknown" />
      </el-select>
      <el-select v-model="listQuery.supplier_gate_status" class="filter-item" clearable placeholder="总开关" size="small" style="width: 130px">
        <el-option label="总开关开启" :value="1" />
        <el-option label="总开关关闭" :value="0" />
      </el-select>
      <el-select v-model="listQuery.last_published_status" class="filter-item" clearable placeholder="最近发布" size="small" style="width: 130px">
        <el-option label="已上架" :value="1" />
        <el-option label="已下架" :value="0" />
      </el-select>
      <el-select v-model="listQuery.last_task_status" class="filter-item" clearable placeholder="最近任务" size="small" style="width: 135px">
        <el-option v-for="item in taskStatuses" :key="item" :label="taskStatusName(item)" :value="item" />
      </el-select>
      <el-select v-model="listQuery.has_error" class="filter-item" clearable placeholder="错误状态" size="small" style="width: 130px">
        <el-option label="仅看有错误" :value="1" />
        <el-option label="全部" :value="0" />
      </el-select>
      <el-button class="filter-item" type="primary" size="small" @click="handleFilter">查询</el-button>
      <el-button class="filter-item" size="small" @click="resetFilter">重置</el-button>
      <el-button class="filter-item" type="warning" size="small" @click="openTasks">同步任务</el-button>
    </div>

    <div v-if="$canEdit" class="sync-toolbar">
      <div class="sync-toolbar-main">
        <span class="sync-title">资源批量操作</span>
        <el-select v-model="fullSupplier" size="small" class="supplier-selector" @change="handleSupplierChange">
          <el-option label="全部资源类型" value="all" />
          <el-option v-for="item in suppliers" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-button-group class="supplier-actions">
          <el-button type="warning" size="small" :loading="fullSyncLoading" @click="syncAll">全量同步</el-button>
          <el-dropdown trigger="click" @command="syncDifferential">
            <el-button type="primary" size="small" :loading="diffSyncLoading">
              差异更新<i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="static">静态资源差异更新</el-dropdown-item>
              <el-dropdown-item command="ari">ARI差异更新</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            type="success"
            size="small"
            :loading="bulkStatusLoading"
            @click="changeAllStatus(1)"
          >一键上架</el-button>
          <el-button
            type="danger"
            size="small"
            :loading="bulkStatusLoading"
            @click="changeAllStatus(0)"
          >一键下架</el-button>
          <el-button
            type="primary"
            size="small"
            :disabled="fullSupplier === 'all' || (supplierSummary && Number(supplierSummary.effective_status) === 0)"
            :loading="newEnrollLoading"
            @click="enrollNew"
          >纳入新房源</el-button>
          <el-button
            type="danger"
            size="small"
            :disabled="fullSupplier === 'all' || (supplierSummary && Number(supplierSummary.effective_status) === 0)"
            :loading="supplierGateLoading"
            @click="changeSupplierStatus(0)"
          >关闭并同步</el-button>
          <el-button
            type="success"
            size="small"
            :disabled="fullSupplier === 'all' || (supplierSummary && Number(supplierSummary.effective_status) === 1)"
            :loading="supplierGateLoading"
            @click="changeSupplierStatus(1)"
          >恢复并同步</el-button>
        </el-button-group>
      </div>
      <div class="sync-toolbar-meta">
        <span v-if="supplierSummary" class="sync-tip">
          总开关：<b>{{ Number(supplierSummary.effective_status) === 1 ? '开启' : '关闭' }}</b>；
          单酒店白名单 {{ supplierSummary.hotel_enabled_total }}/{{ supplierSummary.hotel_total }}；
          历史已发布 {{ supplierSummary.published_total }}；异常 {{ supplierSummary.error_total }}
          ；一键保护 {{ supplierSummary.hotel_locked_total || 0 }}
        </span>
        <span v-else class="sync-tip">选择具体资源类型后可查看影响范围；总开关不会修改单酒店白名单。</span>
        <el-popover placement="bottom-end" title="Dida资源推送操作说明" width="520" trigger="click">
          <div class="operation-help">
            <p><b>执行前：</b>先确认目标范围、源酒店可售状态和单酒店白名单。按钮只创建持久化任务，不会在页面请求内等待Dida处理完成。</p>
            <p><b>单酒店上架并同步：</b>开启该酒店白名单，依次推送酒店静态信息、房型/RatePlan和ARI；供应商总开关关闭时不会绕过总开关。</p>
            <p><b>单酒店下架并同步：</b>必须填写原因；会明确关闭已发布酒店、历史房型/RatePlan及完整滚动ARI，不只是修改本地状态。</p>
            <p><b>单酒店手动同步：</b>不改变白名单，按当前有效状态重推；适合修复数据后重试或核对Dida接收结果。</p>
            <p><b>全量同步：</b>不改变控制状态；只处理所选范围内当前授权酒店，以及以前发布但现在应关闭的历史酒店。</p>
            <p><b>差异更新：</b>静态资源按最后成功快照逐项比较，ARI按完整窗口Payload比较；未变化酒店不请求Dida。</p>
            <p><b>一键上/下架：</b>批量修改所选范围内未锁定酒店并创建全量同步任务；一键下架必须填写原因。</p>
            <p><b>一键保护：</b>锁定的酒店不会被一键上/下架改变；仍可执行明确的单酒店操作，紧急资源类型总开关也仍会生效。</p>
            <p><b>纳入新房源：</b>可选初始Status=0或1。Status=0仍会推送酒店静态资源供Dida匹配，但保持不可售；财务上线后再一键或单店切换为1。</p>
            <p><b>关闭资源类型：</b>紧急关闭所选资源类型的全部已发布资源，并保留每家酒店原白名单；必须填写业务原因。</p>
            <p><b>恢复资源类型：</b>仅恢复原本在单酒店白名单内且当前仍满足授权、配额及可售条件的酒店，不会开放异常测试酒店。</p>
            <p><b>执行与重试：</b>后台通常在10秒内领取任务；临时错误按1/2/5/10/30分钟退避，最多5次。最终失败后先“排查”，修复原因再点“重试”。</p>
            <p><b>结果含义：</b>“推送已受理”表示静态接口成功且ARI已被Dida异步接口受理，不代表Dida最终展示已确认；最终结果仍需Dida侧核对。</p>
            <p><b>审计：</b>任务保留操作人、动作、原因、任务ID和Trace ID。不要直接改任务状态或删除映射记录。</p>
            <p><b>历史保留：</b>成功任务及批次明细保留180天，失败任务及审计证据保留365天；稳定映射和最后成功快照不会按日志清理。</p>
          </div>
          <el-button slot="reference" type="text" icon="el-icon-question" class="help-button">完整操作说明</el-button>
        </el-popover>
      </div>
    </div>

    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row size="small">
      <el-table-column label="资源类型" width="105" align="center">
        <template slot-scope="scope"><el-tag size="mini" effect="plain" :type="supplierTag(scope.row.supplier)">{{ supplierName(scope.row.supplier) }}</el-tag></template>
      </el-table-column>
      <el-table-column label="源酒店编码" min-width="145" align="center">
        <template slot-scope="scope">
          <router-link class="activity-link" :to="{ path: '/dida/activity-rates', query: { supplier: scope.row.supplier, source_hotel_code: scope.row.source_hotel_code } }">{{ scope.row.source_hotel_code }}</router-link>
        </template>
      </el-table-column>
      <el-table-column label="酒店名称" min-width="210" show-overflow-tooltip prop="hotel_name" />
      <el-table-column label="Dida酒店码" min-width="105" align="center">
        <template slot-scope="scope">{{ scope.row.dida_code || '-' }}</template>
      </el-table-column>
      <el-table-column label="协议价 RatePlan" width="125" align="center">
        <template slot-scope="scope">
          <el-tooltip content="已成功推送数 / 当前有效映射总数" placement="top">
            <el-tag size="mini" :type="ratePlanSuccessCount(scope.row, 'protocol') > 0 ? 'success' : 'info'">
              {{ ratePlanSuccessCount(scope.row, 'protocol') }}/{{ ratePlanTotalCount(scope.row, 'protocol') }}
            </el-tag>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="活动价 RatePlan" width="125" align="center">
        <template slot-scope="scope">
          <el-tooltip content="已成功推送数 / 当前有效映射总数；点击查看该酒店活动价明细" placement="top">
            <router-link :to="{ path: '/dida/activity-rates', query: { supplier: scope.row.supplier, source_hotel_code: scope.row.source_hotel_code } }">
              <el-tag size="mini" :type="ratePlanSuccessCount(scope.row, 'activity') > 0 ? 'success' : 'info'">
                {{ ratePlanSuccessCount(scope.row, 'activity') }}/{{ ratePlanTotalCount(scope.row, 'activity') }}
              </el-tag>
            </router-link>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="源状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="isSourceBookable(scope.row) ? 'success' : 'danger'">
            {{ isSourceBookable(scope.row) ? '可售' : '不可售' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="外宾接待" width="105" align="center">
        <template slot-scope="scope">
          <el-tag :type="foreignGuestSupportTag(scope.row.support_foreign_guest)">{{ foreignGuestSupportName(scope.row.support_foreign_guest) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="单店意向" width="105" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="!isSupplierGateUp(scope.row)" content="资源类型总开关关闭；单酒店白名单保持不变" placement="top">
            <el-tag type="warning">总开关关闭</el-tag>
          </el-tooltip>
          <el-tag v-else :type="isHotelDesiredUp(scope.row) ? 'success' : 'danger'">
            {{ isHotelDesiredUp(scope.row) ? '上架' : '下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="一键保护" width="90" align="center">
        <template slot-scope="scope">
          <el-tag :type="Number(scope.row.bulk_operation_locked) === 1 ? 'warning' : 'info'">
            {{ Number(scope.row.bulk_operation_locked) === 1 ? '已锁定' : '未锁定' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="最近发布" width="90" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.last_published_status === null">未发布</span>
          <el-tag v-else :type="Number(scope.row.last_published_status) === 1 ? 'success' : 'info'">
            {{ Number(scope.row.last_published_status) === 1 ? '已上架' : '已下架' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="最近任务" width="105" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.last_task_error" :content="scope.row.last_task_error" placement="top">
            <el-tag :type="taskTagType(scope.row.last_task_status)">{{ taskStatusName(scope.row.last_task_status) }}</el-tag>
          </el-tooltip>
          <el-tag v-else-if="scope.row.last_task_status" :type="taskTagType(scope.row.last_task_status)">
            {{ taskStatusName(scope.row.last_task_status) }}
          </el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="静态成功时间" min-width="150" align="center">
        <template slot-scope="scope">{{ scope.row.last_master_success_at || '-' }}</template>
      </el-table-column>
      <el-table-column label="ARI受理时间" min-width="150" align="center">
        <template slot-scope="scope">{{ scope.row.last_ari_success_at || '-' }}</template>
      </el-table-column>
      <el-table-column label="最近推送错误" min-width="220" show-overflow-tooltip>
        <template slot-scope="scope">{{ failureReason(scope.row.last_error) }}</template>
      </el-table-column>
      <el-table-column v-if="$canEdit" width="560" fixed="right" align="center">
        <template slot="header">
          <span>操作</span>
          <el-popover placement="left" title="单酒店操作说明" width="380" trigger="click">
            <div class="operation-help">
              <p><b>上/下架并同步：</b>修改当前酒店白名单并立即创建同步任务；下架必须填写原因。</p>
              <p><b>手动同步：</b>不改变白名单，按当前有效状态重推静态资源与ARI。</p>
              <p><b>静态差异 / ARI差异：</b>只检查当前酒店，并且只向Dida提交实际发生变化的对应资源。</p>
              <p><b>锁定一键操作：</b>锁定后，一键上架/下架会跳过该酒店；单酒店操作不受影响。</p>
              <p><b>排查：</b>查看源状态、总开关、映射、快照、最近任务和错误。</p>
            </div>
            <i slot="reference" class="el-icon-question operation-help-icon" title="查看单酒店操作说明" />
          </el-popover>
        </template>
        <template slot-scope="scope">
          <div class="row-actions main-row-actions">
            <el-button
              v-if="!isHotelDesiredUp(scope.row)"
              type="success"
              size="mini"
              :loading="rowActionKey === rowKey(scope.row)"
              @click="changeStatus(scope.row, 1)"
            >上架并同步</el-button>
            <el-button
              v-else
              type="danger"
              size="mini"
              :loading="rowActionKey === rowKey(scope.row)"
              @click="changeStatus(scope.row, 0)"
            >下架并同步</el-button>
            <el-button type="warning" size="mini" :disabled="rowActionKey === rowKey(scope.row)" @click="syncHotel(scope.row)">手动同步</el-button>
            <el-button type="primary" plain size="mini" :disabled="rowActionKey === rowKey(scope.row)" @click="syncHotelDifferential(scope.row, 'static')">静态差异</el-button>
            <el-button type="warning" plain size="mini" :disabled="rowActionKey === rowKey(scope.row)" @click="syncHotelDifferential(scope.row, 'ari')">ARI差异</el-button>
            <el-button type="warning" size="mini" :disabled="rowActionKey === rowKey(scope.row)" @click="diagnose(scope.row)">排查</el-button>
            <el-button
              :type="Number(scope.row.bulk_operation_locked) === 1 ? 'info' : 'primary'"
              size="mini"
              :disabled="rowActionKey === rowKey(scope.row)"
              @click="changeLock(scope.row)"
            >{{ Number(scope.row.bulk_operation_locked) === 1 ? '取消一键保护' : '锁定一键操作' }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog title="纳入Dida新房源" :visible.sync="enrollDialogVisible" width="520px">
      <el-alert
        title="Status=0会真实推送酒店静态资源供Dida匹配，但保持不可售；财务上线后再切换为Status=1。"
        type="info"
        :closable="false"
        show-icon
        class="task-help"
      />
      <el-form label-width="110px">
        <el-form-item label="资源类型"><el-tag size="mini" effect="plain" :type="supplierTag(fullSupplier)">{{ supplierName(fullSupplier) }}</el-tag></el-form-item>
        <el-form-item label="初始状态">
          <el-radio-group v-model="enrollInitialStatus">
            <el-radio :label="0">Status=0（先匹配）</el-radio>
            <el-radio :label="1">Status=1（直接上线）</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="操作说明">
          <el-input v-model="enrollReason" maxlength="255" show-word-limit placeholder="例如：首批酒店先推送匹配" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="enrollDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="newEnrollLoading" @click="submitEnrollNew">确认纳入并推送</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Dida手动同步任务" :visible.sync="taskDialogVisible" width="82%" @open="getTasks">
      <el-alert
        class="task-help"
        title="全量任务成功表示静态资源推送成功且ARI请求已被Dida受理；差异任务成功也可能表示没有变化、未发送外部请求。最终是否展示生效仍需Dida侧确认。"
        type="info"
        :closable="false"
        show-icon
      />
      <div class="filter-container">
        <el-select v-model="taskQuery.supplier" class="filter-item" clearable placeholder="资源类型" size="small" style="width: 140px">
          <el-option label="全部资源" value="all" />
          <el-option v-for="item in suppliers" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="taskQuery.status" class="filter-item" clearable placeholder="任务状态" size="small" style="width: 140px">
          <el-option v-for="item in taskStatuses" :key="item" :label="taskStatusName(item)" :value="item" />
        </el-select>
        <el-select v-model="taskQuery.resource_type" class="filter-item" clearable placeholder="任务类型" size="small" style="width: 140px">
          <el-option label="单酒店" value="manual_hotel" />
          <el-option label="全量" value="manual_full" />
          <el-option label="新房源纳入" value="manual_enroll" />
          <el-option label="静态资源差异" value="manual_static" />
          <el-option label="ARI差异" value="manual_ari" />
          <el-option label="单酒店静态差异" value="manual_static_hotel" />
          <el-option label="单酒店ARI差异" value="manual_ari_hotel" />
        </el-select>
        <el-input v-model="taskQuery.hotel_code" class="filter-item" clearable placeholder="酒店编码" size="small" style="width: 180px" />
        <el-button class="filter-item" type="primary" size="small" @click="getTasks">查询</el-button>
        <el-button class="filter-item" size="small" @click="resetTaskFilter">重置</el-button>
      </div>
      <el-table v-loading="taskLoading" :data="tasks" border size="small">
        <el-table-column label="任务ID" width="80" prop="id" align="center" />
        <el-table-column label="类型" width="90" align="center">
          <template slot-scope="scope">{{ taskTypeName(scope.row.resource_type) }}</template>
        </el-table-column>
        <el-table-column label="资源范围" width="110" align="center">
          <template slot-scope="scope"><el-tag size="mini" effect="plain" :type="supplierTag(scope.row.supplier)">{{ scope.row.supplier === 'all' ? '全部' : supplierName(scope.row.supplier) }}</el-tag></template>
        </el-table-column>
        <el-table-column label="酒店编码" min-width="145" prop="hotel_code" />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope"><el-tag :type="taskTagType(scope.row.status)">{{ taskStatusName(scope.row.status) }}</el-tag></template>
        </el-table-column>
        <el-table-column label="操作人" width="110" align="center">
          <template slot-scope="scope">{{ scope.row.operator_name || (scope.row.operator_id ? `#${scope.row.operator_id}` : '-') }}</template>
        </el-table-column>
        <el-table-column label="发起动作" width="120" align="center">
          <template slot-scope="scope">{{ operationActionName(scope.row.operation_action) }}</template>
        </el-table-column>
        <el-table-column label="操作原因" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.operation_reason || '-' }}</template>
        </el-table-column>
        <el-table-column label="重试" width="65" prop="retry_count" align="center" />
        <el-table-column label="失败原因" min-width="300" show-overflow-tooltip>
          <template slot-scope="scope">{{ failureReason(scope.row.last_error) }}</template>
        </el-table-column>
        <el-table-column label="下次重试" width="165" align="center">
          <template slot-scope="scope">{{ scope.row.next_retry_at || '-' }}</template>
        </el-table-column>
        <el-table-column label="更新时间" width="165" prop="updated_at" align="center" />
        <el-table-column label="操作" width="235" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="showTaskFlow(scope.row)">流程</el-button>
            <el-button v-if="isBatchTask(scope.row)" type="text" size="mini" @click="showBatchItems(scope.row)">批次详情</el-button>
            <el-button
              v-if="$canEdit && ['FAILED', 'CANCELLED'].includes(scope.row.status)"
              type="text"
              size="mini"
              @click="retryTask(scope.row)"
            >重试</el-button>
            <el-button
              v-if="$canEdit && ['PENDING', 'PROCESSING', 'RETRY', 'CANCEL_REQUESTED'].includes(scope.row.status)"
              type="text"
              size="mini"
              @click="cancelTask(scope.row)"
            >中断</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          :current-page="taskQuery.page"
          :page-size="taskQuery.limit"
          :total="taskTotal"
          background
          layout="total, prev, pager, next"
          @current-change="handleTaskPage"
        />
      </div>
    </el-dialog>

    <el-dialog title="同步任务流程" :visible.sync="taskFlowVisible" width="650px">
      <template v-if="selectedTask">
        <el-steps :active="taskStepActive(selectedTask)" align-center :finish-status="selectedTask.status === 'FAILED' ? 'error' : (['CANCELLED', 'CANCEL_REQUESTED'].includes(selectedTask.status) ? 'wait' : 'success')">
          <el-step title="已提交" :description="selectedTask.created_at" />
          <el-step title="后台执行" :description="taskExecutionText(selectedTask)" />
          <el-step title="执行结果" :description="taskStatusName(selectedTask.status)" />
        </el-steps>
        <div class="task-detail">
          <p><b>任务ID：</b>{{ selectedTask.id }}</p>
          <p><b>Trace ID：</b><code>{{ taskTraceId(selectedTask) }}</code></p>
          <p><b>范围：</b>{{ selectedTask.supplier === 'all' ? '全部资源类型' : supplierName(selectedTask.supplier) }}</p>
          <p><b>酒店：</b>{{ selectedTask.hotel_code }}</p>
          <p><b>发起动作：</b>{{ operationActionName(selectedTask.operation_action) }}</p>
          <p><b>操作人：</b>{{ selectedTask.operator_name || (selectedTask.operator_id ? `#${selectedTask.operator_id}` : '-') }}；<b>操作时间：</b>{{ selectedTask.operation_at || '-' }}</p>
          <p><b>操作原因：</b>{{ selectedTask.operation_reason || '-' }}</p>
          <p><b>重试次数：</b>{{ selectedTask.retry_count }}；<b>下次自动重试：</b>{{ selectedTask.next_retry_at || '-' }}</p>
          <el-alert
            v-if="selectedTask.last_error"
            :title="['CANCELLED', 'CANCEL_REQUESTED'].includes(selectedTask.status) ? '任务中断说明' : '推送失败原因'"
            :description="failureReason(selectedTask.last_error)"
            :type="['CANCELLED', 'CANCEL_REQUESTED'].includes(selectedTask.status) ? 'warning' : 'error'"
            :closable="false"
            show-icon
          />
        </div>
      </template>
    </el-dialog>

    <el-dialog :title="batchTaskTitle(batchTask)" :visible.sync="batchVisible" width="88%">
      <template v-if="batchTask">
        <el-alert
          title="本页按酒店展示同一批量任务的执行结果。差异任务的成功酒店可能没有变化、未发送外部请求；失败酒店可单独重推，整批终态失败时也可重试整个批次。"
          type="info"
          :closable="false"
          show-icon
        />
        <div class="batch-summary">
          <el-tag>总计 {{ batchSummary.total || 0 }}</el-tag>
          <el-tag type="success">成功 {{ batchSummary.success || 0 }}</el-tag>
          <el-tag type="danger">失败 {{ batchSummary.failed || 0 }}</el-tag>
          <el-tag type="warning">执行中 {{ batchSummary.processing || 0 }}</el-tag>
          <el-tag type="info">待执行 {{ batchSummary.pending || 0 }}</el-tag>
          <el-tag type="warning">已中断 {{ batchSummary.cancelled || 0 }}</el-tag>
          <el-button
            v-if="$canEdit && ['FAILED', 'CANCELLED'].includes(batchTask.status)"
            type="warning"
            size="small"
            @click="retryTask(batchTask)"
          >重试整个批次</el-button>
          <el-button
            v-if="$canEdit && ['PENDING', 'PROCESSING', 'RETRY', 'CANCEL_REQUESTED'].includes(batchTask.status)"
            type="danger"
            size="small"
            @click="cancelTask(batchTask)"
          >中断任务</el-button>
          <el-button
            v-if="$canEdit && batchTask.status === 'FAILED'"
            type="danger"
            size="small"
            :disabled="!batchSelection.length"
            @click="retrySelectedBatchItems"
          >批量重推所选失败酒店（{{ batchSelection.length }}）</el-button>
        </div>
        <el-alert
          v-if="!batchLoading && Number(batchSummary.total || 0) === 0"
          title="该批次没有逐酒店明细，可能是当前没有符合条件的新酒店，或旧版本历史任务无法可靠反推逐酒店结果。"
          type="warning"
          :closable="false"
          show-icon
          class="task-help"
        />
        <div class="filter-container">
          <el-select v-model="batchQuery.status" class="filter-item" clearable placeholder="酒店结果" size="small" style="width: 130px" @change="handleBatchFilter">
            <el-option label="成功" value="SUCCESS" />
            <el-option label="失败" value="FAILED" />
            <el-option label="执行中" value="PROCESSING" />
            <el-option label="待执行" value="PENDING" />
            <el-option label="已中断" value="CANCELLED" />
          </el-select>
          <el-select v-model="batchQuery.supplier" class="filter-item" clearable placeholder="资源类型" size="small" style="width: 130px" @change="handleBatchFilter">
            <el-option v-for="item in suppliers" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
          <el-input v-model="batchQuery.hotel_code" class="filter-item" clearable placeholder="酒店编码" size="small" style="width: 180px" @keyup.enter.native="handleBatchFilter" />
          <el-button class="filter-item" type="primary" size="small" @click="handleBatchFilter">查询</el-button>
          <el-button class="filter-item" type="warning" size="small" icon="el-icon-refresh" @click="getBatchItems">刷新</el-button>
        </div>
        <el-table v-loading="batchLoading" :data="batchItems" border size="small" @selection-change="handleBatchSelection">
          <el-table-column v-if="$canEdit" type="selection" width="45" :selectable="batchItemSelectable" />
          <el-table-column prop="id" label="明细ID" width="85" align="center" />
          <el-table-column label="资源类型" width="95" align="center"><template slot-scope="scope"><el-tag size="mini" effect="plain" :type="supplierTag(scope.row.supplier)">{{ supplierName(scope.row.supplier) }}</el-tag></template></el-table-column>
          <el-table-column prop="hotel_code" label="酒店编码" min-width="145" show-overflow-tooltip />
          <el-table-column prop="hotel_name" label="酒店名称" min-width="190" show-overflow-tooltip><template slot-scope="scope">{{ scope.row.hotel_name || '-' }}</template></el-table-column>
          <el-table-column label="结果" width="95" align="center"><template slot-scope="scope"><el-tag :type="taskTagType(scope.row.status)" size="mini">{{ taskStatusName(scope.row.status) }}</el-tag></template></el-table-column>
          <el-table-column prop="attempt_count" label="执行次数" width="85" align="center" />
          <el-table-column label="失败原因" min-width="330" show-overflow-tooltip><template slot-scope="scope">{{ failureReason(scope.row.last_error) }}</template></el-table-column>
          <el-table-column prop="last_started_at" label="开始时间" width="165"><template slot-scope="scope">{{ scope.row.last_started_at || '-' }}</template></el-table-column>
          <el-table-column prop="completed_at" label="完成时间" width="165"><template slot-scope="scope">{{ scope.row.completed_at || '-' }}</template></el-table-column>
          <el-table-column v-if="$canEdit" label="操作" width="110" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button v-if="batchTask.status === 'FAILED' && scope.row.status === 'FAILED'" type="danger" size="mini" @click="retryBatchHotel(scope.row)">单独重推</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination
            :current-page="batchQuery.page"
            :page-size="batchQuery.limit"
            :page-sizes="[10, 20, 50, 100]"
            :total="batchTotal"
            layout="total, sizes, prev, pager, next"
            @size-change="handleBatchSize"
            @current-change="handleBatchPage"
          />
        </div>
      </template>
    </el-dialog>

    <el-dialog title="酒店推送诊断" :visible.sync="diagnosticVisible" width="78%">
      <div v-loading="diagnosticLoading">
        <template v-if="diagnostic">
          <el-alert
            v-if="diagnostic.issues && diagnostic.issues.length"
            title="发现需要关注的问题"
            type="warning"
            :closable="false"
            show-icon
          >
            <div v-for="(issue, index) in diagnostic.issues" :key="index">{{ index + 1 }}. {{ issue }}</div>
          </el-alert>
          <el-alert v-else title="本地发布状态未发现明显问题" type="success" :closable="false" show-icon />
          <el-alert
            v-if="diagnostic.control && diagnostic.control.last_error"
            class="diagnostic-error"
            title="最近推送失败原因"
            :description="failureReason(diagnostic.control.last_error)"
            type="error"
            :closable="false"
            show-icon
          />
          <el-row :gutter="12" class="diagnostic-cards">
            <el-col :span="6"><el-card shadow="never"><div class="metric">{{ diagnostic.hotel_mapping ? diagnostic.hotel_mapping.dida_code : '-' }}</div><div>Dida酒店码</div></el-card></el-col>
            <el-col :span="6"><el-card shadow="never"><div class="metric">{{ snapshotValue('static_active') }}</div><div>有效静态快照</div></el-card></el-col>
            <el-col :span="6"><el-card shadow="never"><div class="metric">{{ snapshotValue('ari_inventory_active') }}</div><div>有效库存快照</div></el-card></el-col>
            <el-col :span="6"><el-card shadow="never"><div class="metric">{{ snapshotValue('ari_rate_active') }}</div><div>有效价格快照</div></el-card></el-col>
          </el-row>
          <el-row :gutter="12" class="rate-summary-cards">
            <el-col :span="8"><el-card shadow="never"><div class="rate-summary-title">协议价</div><strong>{{ rateSummary('protocol', 'rate_plans') }}</strong><span>个有效 RatePlan</span><small>{{ rateSummary('protocol', 'ari_rates') }} 个有效 ARI 价格点</small></el-card></el-col>
            <el-col :span="8"><el-card shadow="never"><div class="rate-summary-title">活动价</div><strong>{{ rateSummary('activity', 'rate_plans') }}</strong><span>个有效 RatePlan</span><small>{{ rateSummary('activity', 'ari_rates') }} 个有效 ARI 价格点</small></el-card></el-col>
            <el-col :span="8"><el-card shadow="never" :class="{ 'is-unclassified': rateSummary('unclassified', 'rate_plans') > 0 }"><div class="rate-summary-title">待分类</div><strong>{{ rateSummary('unclassified', 'rate_plans') }}</strong><span>个有效 RatePlan</span><small>{{ rateSummary('unclassified', 'ari_rates') }} 个有效 ARI 价格点</small></el-card></el-col>
          </el-row>
          <div class="snapshot-toolbar">
            <el-button size="small" icon="el-icon-refresh" :loading="diagnosticLoading" @click="diagnose(diagnostic.control, false)">刷新诊断与明细</el-button>
            <el-button v-if="$canEdit" size="small" type="warning" :disabled="rowActionKey === rowKey(diagnostic.control)" @click="syncHotel(diagnostic.control)">按当前状态重推酒店</el-button>
          </div>
          <h4>资源映射</h4>
          <el-table :data="diagnostic.mapping_counts || []" border size="small">
            <el-table-column label="资源类型" prop="resource_type" />
            <el-table-column label="映射总数" prop="total" />
            <el-table-column label="有效映射" prop="active_total" />
          </el-table>
          <h4>协议价 / 活动价 RatePlan 映射明细</h4>
          <el-alert title="分类以源 product_type 为准：0/1/2/3 为协议价，4/5 为活动价；预订时间和星期规则只控制可售。下表展示源房型、源产品映射到的 Dida RoomTypeCode / RatePlanCode，以及当前有效 ARI 日期数。" type="info" :closable="false" show-icon class="task-help" />
          <div class="snapshot-toolbar">
            <el-select v-model="rateMappingQuery.rate_category" clearable size="small" placeholder="价格类型" style="width: 130px" @change="handleRateMappingFilter">
              <el-option label="协议价" value="protocol" />
              <el-option label="活动价" value="activity" />
              <el-option label="待分类" value="unclassified" />
            </el-select>
            <el-select v-model="rateMappingQuery.active" clearable size="small" placeholder="映射状态" style="width: 120px" @change="handleRateMappingFilter">
              <el-option label="有效" :value="1" />
              <el-option label="已失效" :value="0" />
            </el-select>
            <el-select v-model="rateMappingQuery.meal_count" clearable size="small" placeholder="早餐份数" style="width: 130px" @change="handleRateMappingFilter">
              <el-option label="无早（0份）" :value="0" />
              <el-option label="单早（1份）" :value="1" />
              <el-option label="双早（2份）" :value="2" />
              <el-option label="3份早餐" :value="3" />
              <el-option label="4份早餐" :value="4" />
            </el-select>
            <el-input v-model="rateMappingQuery.source_room_type_code" clearable size="small" placeholder="源房型编码" style="width: 145px" @keyup.enter.native="handleRateMappingFilter" @clear="handleRateMappingFilter" />
            <el-input v-model="rateMappingQuery.source_product_code" clearable size="small" placeholder="源产品编码" style="width: 145px" @keyup.enter.native="handleRateMappingFilter" @clear="handleRateMappingFilter" />
            <el-input v-model="rateMappingQuery.dida_code" clearable size="small" placeholder="Dida RatePlanCode" style="width: 170px" @keyup.enter.native="handleRateMappingFilter" @clear="handleRateMappingFilter" />
            <el-button size="small" type="primary" @click="handleRateMappingFilter">查询</el-button>
            <el-button size="small" @click="resetRateMappingFilters">重置</el-button>
          </div>
          <el-table v-loading="rateMappingLoading" :data="rateMappings" border size="small">
            <el-table-column label="类型" width="85" align="center"><template slot-scope="scope"><el-tag size="mini" :type="rateCategoryTag(scope.row.rate_category)">{{ rateCategoryName(scope.row.rate_category) }}</el-tag></template></el-table-column>
            <el-table-column prop="source_room_type_code" label="源房型" min-width="125" show-overflow-tooltip />
            <el-table-column prop="source_product_code" label="源产品" min-width="135" show-overflow-tooltip />
            <el-table-column label="映射到 Dida" min-width="290"><template slot-scope="scope"><div>{{ scope.row.dida_room_type_code || '-' }}</div><strong>→ {{ scope.row.dida_rate_plan_code }}</strong></template></el-table-column>
            <el-table-column label="人数 / 早餐映射" min-width="190">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.meal_count == null ? 'warning' : 'success'">{{ mealCountName(scope.row.meal_count) }}</el-tag>
                <div class="rate-plan-meta">入住 {{ scope.row.base_person_count == null ? '-' : scope.row.base_person_count }} 人 · {{ scope.row.meal_type_name || '-' }}</div>
              </template>
            </el-table-column>
            <el-table-column label="国籍限制" min-width="170" show-overflow-tooltip><template slot-scope="scope">{{ nationalityRuleName(scope.row) }}</template></el-table-column>
            <el-table-column label="映射" width="80" align="center"><template slot-scope="scope"><el-tag size="mini" :type="scope.row.mapping_active === 1 ? 'success' : 'info'">{{ scope.row.mapping_active === 1 ? '有效' : '失效' }}</el-tag></template></el-table-column>
            <el-table-column label="RatePlan推送" width="110" align="center"><template slot-scope="scope"><el-tag size="mini" :type="scope.row.master_publish_status === 1 ? 'success' : (scope.row.master_publish_status === 0 ? 'info' : 'warning')">{{ scope.row.master_publish_status === 1 ? '已推送有效' : (scope.row.master_publish_status === 0 ? '已推送失效' : '无成功快照') }}</el-tag></template></el-table-column>
            <el-table-column prop="active_ari_points" label="有效ARI点" width="95" align="right" />
            <el-table-column label="有效入住日期" min-width="190"><template slot-scope="scope">{{ scope.row.first_active_stay_date || '-' }} 至 {{ scope.row.last_active_stay_date || '-' }}</template></el-table-column>
            <el-table-column prop="master_last_success_at" label="RatePlan接受时间" width="165"><template slot-scope="scope">{{ scope.row.master_last_success_at || '-' }}</template></el-table-column>
            <el-table-column prop="last_ari_success_at" label="最近ARI接受时间" width="165"><template slot-scope="scope">{{ scope.row.last_ari_success_at || '-' }}</template></el-table-column>
          </el-table>
          <div class="snapshot-pagination"><el-pagination :current-page="rateMappingQuery.page" :page-size="rateMappingQuery.limit" :page-sizes="[10, 20, 50, 100]" :total="rateMappingTotal" layout="total, sizes, prev, pager, next" small @size-change="handleRateMappingSizeChange" @current-change="handleRateMappingPageChange" /></div>
          <h4>酒店、房型、RatePlan 与 ARI 推送对照</h4>
          <el-alert
            title="Dida目前没有提供静态资源/ARI最终展示回查接口。右侧数据来自Dida接口返回成功后保存的实际请求快照，可用于判断我们推了什么；不能替代Dida侧最终展示核对。接口失败时不会覆盖成功快照，失败原因见上方和最近任务。"
            type="warning"
            :closable="false"
            show-icon
            class="task-help"
          />
          <div class="snapshot-toolbar">
            <el-select v-model="diagnosticSnapshotQuery.kind" size="small" style="width: 150px" @change="handleSnapshotKindChange">
              <el-option label="酒店静态" value="hotel" />
              <el-option label="房型静态" value="room" />
              <el-option label="RatePlan静态" value="rate_plan" />
              <el-option label="库存ARI" value="inventory" />
              <el-option label="价格ARI" value="rate" />
            </el-select>
            <el-select v-model="diagnosticSnapshotQuery.publish_status" clearable size="small" placeholder="发布状态" style="width: 130px" @change="handleSnapshotFilter">
              <el-option label="有效" :value="1" />
              <el-option label="已失效" :value="0" />
            </el-select>
            <el-input v-model="diagnosticSnapshotQuery.resource_code" clearable size="small" placeholder="道旅资源编码" style="width: 180px" @keyup.enter.native="handleSnapshotFilter" @clear="handleSnapshotFilter" />
            <el-input v-if="diagnosticSnapshotQuery.kind !== 'hotel'" v-model="diagnosticSnapshotQuery.source_room_type_code" clearable size="small" placeholder="源房型编码" style="width: 150px" @keyup.enter.native="handleSnapshotFilter" @clear="handleSnapshotFilter" />
            <el-input v-if="['rate_plan', 'rate'].includes(diagnosticSnapshotQuery.kind)" v-model="diagnosticSnapshotQuery.source_product_code" clearable size="small" placeholder="源产品编码" style="width: 150px" @keyup.enter.native="handleSnapshotFilter" @clear="handleSnapshotFilter" />
            <el-date-picker v-if="['inventory', 'rate'].includes(diagnosticSnapshotQuery.kind)" v-model="diagnosticSnapshotQuery.stay_date" type="date" value-format="yyyy-MM-dd" clearable size="small" placeholder="入住日期" style="width: 145px" @change="handleSnapshotFilter" />
            <el-button type="primary" size="small" @click="handleSnapshotFilter">查询</el-button>
            <el-button size="small" @click="resetSnapshotFilters">重置</el-button>
            <el-button type="text" size="small" icon="el-icon-question" @click="enumVisible = true">Dida枚举说明</el-button>
            <span class="snapshot-tip">左侧是平台当前数据，右侧是Dida最后一次明确接受的快照；差异可能表示源数据已变化但尚未重推。</span>
          </div>
          <el-alert
            v-if="diagnosticSnapshotQuery.kind === 'rate_plan'"
            title="同一源产品在不同入住日早餐份数不同时，会拆成多个静态 RatePlan；每行只对照与该 RatePlan MealCount 匹配的源日期。"
            type="info"
            :closable="false"
            show-icon
            class="task-help"
          />
          <el-table v-loading="diagnosticSnapshotLoading" :data="diagnosticSnapshots" border size="small">
            <el-table-column type="expand" width="44">
              <template slot-scope="scope">
                <div class="comparison-detail-title">
                  <b>逐字段推送对照</b>
                  <span>“未推送”表示Dida对应接口没有该字段，不代表平台源数据缺失。</span>
                </div>
                <el-alert v-if="scope.row.source_missing" title="平台当前源记录不存在；这里只能展示历史Dida成功快照。" type="warning" :closable="false" show-icon class="task-help" />
                <el-alert v-if="diagnosticSnapshotQuery.kind === 'rate_plan' && (scope.row.publish_status === 0 || scope.row.snapshot_state === 'source_newer')" title="每条房态按自身入住日期计算 HourCount。此 RatePlan 是没有入住日期的历史快照；请按具体日期查看对应 ARI，不能用当前任意一天的规则反推历史值。" type="warning" :closable="false" show-icon class="task-help" />
                <div v-if="diagnosticSnapshotQuery.kind === 'rate_plan'" class="rule-comparison">
                  <div><b>平台当前源取消规则（各入住日期独立）</b><pre>{{ prettyJSON(scope.row.source_cancel_rules || []) }}</pre></div>
                  <div><b>道旅最后接受的映射</b><pre>{{ prettyJSON(scope.row.dida_cancel_rule || {}) }}</pre></div>
                </div>
                <el-table :data="scope.row.comparison_fields || []" border size="mini" class="comparison-table">
                  <el-table-column prop="label" label="业务字段" width="125" />
                  <el-table-column prop="source_field" label="平台源字段" min-width="155" show-overflow-tooltip />
                  <el-table-column prop="source_value" label="平台当前值" min-width="220" show-overflow-tooltip />
                  <el-table-column label="映射结果" width="105" align="center"><template slot-scope="fieldScope"><el-tag size="mini" :type="comparisonTagType(fieldScope.row.result)">{{ comparisonResultName(fieldScope.row.result) }}</el-tag></template></el-table-column>
                  <el-table-column prop="dida_field" label="Dida字段" min-width="160"><template slot-scope="fieldScope">{{ fieldScope.row.dida_field || '-' }}</template></el-table-column>
                  <el-table-column prop="dida_value" label="最后推送值" min-width="220" show-overflow-tooltip />
                  <el-table-column prop="note" label="映射/未推送说明" min-width="260" show-overflow-tooltip />
                </el-table>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="85" align="center"><template slot-scope="scope"><el-tag size="mini" :type="scope.row.publish_status === 1 ? 'success' : 'info'">{{ scope.row.publish_status === 1 ? '有效' : '已失效' }}</el-tag></template></el-table-column>
            <el-table-column label="资源标识" min-width="190" show-overflow-tooltip><template slot-scope="scope">{{ snapshotIdentity(scope.row) }}</template></el-table-column>
            <el-table-column v-if="['inventory', 'rate'].includes(diagnosticSnapshotQuery.kind)" prop="stay_date" label="入住日期" width="115" />
            <el-table-column label="问题判断" width="150" align="center"><template slot-scope="scope"><el-tag :type="snapshotStateTag(scope.row.snapshot_state)" size="mini">{{ scope.row.snapshot_state_text || '待判断' }}</el-tag></template></el-table-column>
            <el-table-column label="平台当前数据" min-width="300" show-overflow-tooltip><template slot-scope="scope">{{ comparisonSideSummary(scope.row, 'source') }}</template></el-table-column>
            <el-table-column label="→ Dida最后推送值" min-width="300" show-overflow-tooltip><template slot-scope="scope">{{ comparisonSideSummary(scope.row, 'dida') }}</template></el-table-column>
            <el-table-column label="对照结论" width="210"><template slot-scope="scope"><div class="comparison-tags"><el-tag v-if="summaryCount(scope.row, 'different')" type="danger" size="mini">差异 {{ summaryCount(scope.row, 'different') }}</el-tag><el-tag v-if="summaryCount(scope.row, 'mapped')" type="warning" size="mini">转换 {{ summaryCount(scope.row, 'mapped') }}</el-tag><el-tag v-if="summaryCount(scope.row, 'fixed')" size="mini">固定 {{ summaryCount(scope.row, 'fixed') }}</el-tag><el-tag v-if="summaryCount(scope.row, 'not_pushed')" type="info" size="mini">未推送 {{ summaryCount(scope.row, 'not_pushed') }}</el-tag><el-tag v-if="!summaryCount(scope.row, 'different')" type="success" size="mini">无直接差异</el-tag></div></template></el-table-column>
            <el-table-column prop="source_updated_at" label="平台更新时间" width="165"><template slot-scope="scope">{{ scope.row.source_updated_at || '-' }}</template></el-table-column>
            <el-table-column prop="last_success_at" label="Dida接受时间" width="165" />
            <el-table-column prop="inactive_at" label="失效时间" width="165"><template slot-scope="scope">{{ scope.row.inactive_at || '-' }}</template></el-table-column>
          </el-table>
          <div class="snapshot-pagination">
            <el-pagination
              :current-page="diagnosticSnapshotQuery.page"
              :page-size="diagnosticSnapshotQuery.limit"
              :page-sizes="[10, 20, 50, 100]"
              :total="diagnosticSnapshotTotal"
              layout="total, sizes, prev, pager, next"
              small
              @size-change="handleSnapshotSizeChange"
              @current-change="handleSnapshotPageChange"
            />
          </div>
          <h4>平台源房态与未推送资源</h4>
          <el-alert title="数据量较大，请指定入住日期或源房型、产品编码后查询。只读取当前页源房态与相关道旅快照；无快照不等于已确认被规则过滤。范围为昨日到未来18天。" type="info" :closable="false" show-icon class="task-help" />
          <div v-if="sourceStatusQueried" class="snapshot-toolbar">
            <span class="snapshot-tip">本页：</span>
            <el-tag size="small" type="success">Status=1 {{ sourceStatusSummary.accepted || 0 }}</el-tag>
            <el-tag size="small" type="warning">Status=0 {{ sourceStatusSummary.inactive || 0 }}</el-tag>
            <el-tag size="small" type="danger">同步后无快照 {{ sourceStatusSummary.excluded || 0 }}</el-tag>
            <el-tag size="small" type="info">待同步/待确认 {{ sourceStatusSummary.pending || 0 }}</el-tag>
            <span class="snapshot-tip">最近ARI成功：{{ sourceStatusLastARI || (diagnostic.control && diagnostic.control.last_ari_success_at) || '-' }}</span>
          </div>
          <div class="snapshot-toolbar">
            <el-input v-model="sourceStatusQuery.room_type_code" clearable size="small" placeholder="源房型编码（精确）" style="width: 165px" @keyup.enter.native="handleSourceStatusFilter" />
            <el-input v-model="sourceStatusQuery.product_code" clearable size="small" placeholder="源产品编码（精确）" style="width: 165px" @keyup.enter.native="handleSourceStatusFilter" />
            <el-date-picker v-model="sourceStatusQuery.stay_date" type="date" value-format="yyyy-MM-dd" clearable size="small" placeholder="入住日期" style="width: 145px" />
            <el-button size="small" type="primary" @click="handleSourceStatusFilter">筛选</el-button>
            <el-button size="small" @click="resetSourceStatusFilters">重置</el-button>
            <el-button size="small" icon="el-icon-refresh" @click="getSourceStatuses">刷新</el-button>
          </div>
          <div v-if="!sourceStatusQueried" class="source-query-hint">请输入入住日期或源房型、产品编码，再点击“筛选”。</div>
          <el-table v-else v-loading="sourceStatusLoading" :data="sourceStatuses" border size="small">
            <el-table-column type="expand" width="44">
              <template slot-scope="scope">
                <div class="rule-comparison">
                  <div><b>平台源取消规则 / 预订规则</b><pre>{{ prettyJSON(scope.row.cancel_rule_parsed || scope.row.cancel_rule) }}</pre><pre>{{ prettyJSON(scope.row.book_rule) }}</pre></div>
                  <div><b>道旅最后接受的取消规则映射（最多展示 10 条）</b><pre>{{ prettyJSON(scope.row.mapped_rules || []) }}</pre></div>
                </div>
                <div><b>道旅RatePlan编码：</b>{{ (scope.row.dida_rate_plan_codes || []).join('、') || '尚无映射' }}（展示 {{ (scope.row.dida_rate_plan_codes || []).length }} / 共 {{ scope.row.dida_rate_plan_total || 0 }}）</div>
                <div><b>已接受价格快照（最多展示 10 条，匹配共 {{ scope.row.accepted_rates_total || 0 }} 条）：</b><pre>{{ prettyJSON(scope.row.accepted_rates || []) }}</pre></div>
              </template>
            </el-table-column>
            <el-table-column prop="stay_date" label="入住日期" width="115" />
            <el-table-column prop="room_type_code" label="源房型" min-width="120" show-overflow-tooltip />
            <el-table-column prop="product_code" label="源产品" min-width="120" show-overflow-tooltip />
            <el-table-column prop="product_name" label="产品名称" min-width="150" show-overflow-tooltip />
            <el-table-column prop="advance_rate" label="源价" width="90" />
            <el-table-column prop="quota" label="房量" width="80" />
            <el-table-column label="对照状态" width="145"><template slot-scope="scope"><el-tag size="mini" :type="sourceStatusTag(scope.row.review_status)">{{ sourceStatusName(scope.row.review_status) }}</el-tag></template></el-table-column>
            <el-table-column label="未推送 / 不可售原因" min-width="340"><template slot-scope="scope">{{ (scope.row.reasons || []).join('；') || '-' }}</template></el-table-column>
            <el-table-column prop="source_updated_at" label="源更新时间" width="165" />
          </el-table>
          <div v-if="sourceStatusQueried" class="snapshot-pagination"><el-pagination :current-page="sourceStatusQuery.page" :page-size="sourceStatusQuery.limit" :page-sizes="[10, 20, 50, 100]" :total="sourceStatusTotal" layout="total, sizes, prev, pager, next" small @size-change="handleSourceStatusSizeChange" @current-change="handleSourceStatusPageChange" /></div>
          <h4>最近单酒店任务</h4>
          <el-table :data="diagnostic.recent_tasks || []" border size="small">
            <el-table-column label="任务ID" prop="id" width="80" />
            <el-table-column label="状态" width="100"><template slot-scope="scope"><el-tag :type="taskTagType(scope.row.status)">{{ taskStatusName(scope.row.status) }}</el-tag></template></el-table-column>
            <el-table-column label="发起人" width="110"><template slot-scope="scope">{{ scope.row.operator_name || (scope.row.operator_id ? `#${scope.row.operator_id}` : '-') }}</template></el-table-column>
            <el-table-column label="动作" width="120"><template slot-scope="scope">{{ operationActionName(scope.row.operation_action) }}</template></el-table-column>
            <el-table-column label="重试" prop="retry_count" width="65" />
            <el-table-column label="失败原因" min-width="300" show-overflow-tooltip><template slot-scope="scope">{{ failureReason(scope.row.last_error) }}</template></el-table-column>
            <el-table-column label="更新时间" prop="updated_at" width="165" />
            <el-table-column label="操作" width="80"><template slot-scope="scope"><el-button v-if="$canEdit && scope.row.status === 'FAILED'" type="text" @click="retryTask(scope.row)">重试</el-button></template></el-table-column>
          </el-table>
        </template>
      </div>
    </el-dialog>

    <el-dialog title="Dida字段枚举与含义" :visible.sync="enumVisible" width="720px" append-to-body>
      <el-alert title="以下枚举来自项目内固定版本的Dida Channel Manager接口文档；页面展示的是实际推送值。" type="info" :closable="false" show-icon class="task-help" />
      <el-collapse accordion>
        <el-collapse-item title="发布状态、确认方式与ARI限制" name="common">
          <el-table :data="didaCommonEnums" border size="small"><el-table-column prop="field" label="字段" width="150" /><el-table-column prop="value" label="值" width="130" /><el-table-column prop="meaning" label="含义" /></el-table>
        </el-collapse-item>
        <el-collapse-item title="餐型 MealTypeID" name="meal">
          <el-table :data="didaMealEnums" border size="small" max-height="360"><el-table-column prop="id" label="ID" width="90" /><el-table-column prop="name" label="Dida名称" /><el-table-column prop="note" label="当前使用说明" /></el-table>
        </el-collapse-item>
        <el-collapse-item title="主要床型 BedTypeID" name="bed">
          <el-table :data="didaBedEnums" border size="small" max-height="360"><el-table-column prop="id" label="ID" width="90" /><el-table-column prop="name" label="Dida名称" /></el-table>
        </el-collapse-item>
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import DidaModuleHeader from './DidaModuleHeader.vue'

export default {
  name: 'DidaHotelPublishControls',
  components: { DidaModuleHeader },
  data() {
    return {
      suppliers: [
        { label: '锦江', value: 'jin_jiang' },
        { label: '龙腾', value: 'long_teng' },
        { label: '隧穿亚朵', value: 'sui_chuan' },
        { label: '丽呈', value: 'li_cheng' },
      ],
      taskStatuses: ['PENDING', 'PROCESSING', 'RETRY', 'CANCEL_REQUESTED', 'SUCCESS', 'FAILED', 'CANCELLED'],
      enumVisible: false,
      didaCommonEnums: [
        { field: 'Status', value: '0', meaning: 'InActive，不可售/失效' },
        { field: 'Status', value: '1', meaning: 'Active，可售/有效' },
        { field: 'IsOnRequest', value: 'false', meaning: '即时确认产品' },
        { field: 'IsOnRequest', value: 'true', meaning: 'OnRequest产品，需要后续确认' },
        { field: 'CTA', value: 'true / false / null', meaning: '禁止入住 / 允许入住 / 不限制' },
        { field: 'CTD', value: 'true / false / null', meaning: '禁止离店 / 允许离店 / 不限制' },
        { field: 'PriceModel', value: 'PDP', meaning: '每日每房价格模式' },
      ],
      didaMealEnums: [
        { id: 0, name: 'Room Only', note: '当前用于无早' },
        { id: 1, name: 'Breakfast Included', note: '当前仅用于单早配1人、双早配2人' },
        { id: 2, name: 'Half-Board', note: '当前不使用' }, { id: 3, name: 'Full-Board', note: '当前不使用' },
        { id: 4, name: 'All Inclusive', note: '当前不使用' }, { id: 5, name: 'Dinner', note: '当前不使用' },
        { id: 6, name: 'BreakfastAndDinner', note: '当前不使用' }, { id: 7, name: 'BreakfastAndLunch', note: '当前不使用' },
        { id: 8, name: 'PKG(Room&Ticket)', note: '当前不使用' }, { id: 9, name: 'Lunch', note: '当前不使用' },
        { id: 10, name: 'Lunch And Dinner', note: '当前不使用' }, { id: 11, name: 'Suhur', note: '当前不使用' },
        { id: 12, name: 'Iftar', note: '当前不使用' }, { id: 13, name: 'Suhur And Iftar', note: '当前不使用' },
        { id: 14, name: 'Suhur or Iftar', note: '当前不使用' },
      ],
      didaBedEnums: [
        { id: 1, name: '1 Single' }, { id: 2, name: '1 Double' }, { id: 3, name: '1 Twin' },
        { id: 4, name: '3 Single' }, { id: 5, name: '1 Double 1 Single' }, { id: 6, name: '2 Double' },
        { id: 7, name: '1 Double 1 Twin' }, { id: 8, name: '2 Twin' }, { id: 9, name: '1 Double or 1 Twin' },
        { id: 10, name: '1 Double 1 Sofa' }, { id: 11, name: '1 Single 1 Sofa' }, { id: 14, name: '2 Single 1 Sofa' },
        { id: 15, name: '3 Single 1 Sofa' }, { id: 16, name: '4 Single 1 Sofa' }, { id: 17, name: '2 Double 1 Sofa' },
        { id: 18, name: '1 Double 2 Sofa' }, { id: 21, name: '1 Double 1 Single 1 Sofa' },
        { id: 22, name: '1 Double 2 Single 1 Sofa' }, { id: 23, name: '1 Double 2 Single 1 Double-Sofa' },
        { id: 24, name: '1 Sofa' },
      ],
      list: [],
      total: 0,
      listLoading: false,
      lastRefreshedAt: '',
      listError: '',
      listQuery: {
        page: 1,
        limit: 20,
        supplier: '',
        ari_sort: 'desc',
        ari_health: '',
        rate_category: '',
        rate_publish_status: '',
        source_hotel_code: '',
        dida_hotel_code: '',
        hotel_name: '',
        desired_status: '',
        bulk_operation_locked: '',
        source_status: '',
        foreign_guest_status: '',
        supplier_gate_status: '',
        last_published_status: '',
        last_task_status: '',
        has_error: '',
      },
      fullSupplier: 'all',
      fullSyncLoading: false,
      diffSyncLoading: false,
      bulkStatusLoading: false,
      newEnrollLoading: false,
      supplierGateLoading: false,
      supplierSummary: null,
      enrollDialogVisible: false,
      enrollInitialStatus: 0,
      enrollReason: '首批酒店先推送匹配',
      rowActionKey: '',
      taskDialogVisible: false,
      taskLoading: false,
      tasks: [],
      taskTotal: 0,
      taskQuery: { page: 1, limit: 20, supplier: '', status: '', resource_type: '', hotel_code: '' },
      taskFlowVisible: false,
      selectedTask: null,
      batchVisible: false,
      batchLoading: false,
      batchTask: null,
      batchItems: [],
      batchTotal: 0,
      batchSummary: {},
      batchSelection: [],
      batchQuery: { status: '', supplier: '', hotel_code: '', page: 1, limit: 20 },
      diagnosticVisible: false,
      diagnosticLoading: false,
      diagnostic: null,
      diagnosticSnapshots: [],
      diagnosticSnapshotTotal: 0,
      diagnosticSnapshotLoading: false,
      diagnosticSnapshotQuery: { kind: 'hotel', publish_status: '', resource_code: '', source_room_type_code: '', source_product_code: '', stay_date: '', page: 1, limit: 20 },
      rateMappings: [],
      rateMappingTotal: 0,
      rateMappingLoading: false,
      rateMappingQuery: { rate_category: '', active: 1, meal_count: '', source_room_type_code: '', source_product_code: '', dida_code: '', page: 1, limit: 20 },
      sourceStatuses: [],
      sourceStatusTotal: 0,
      sourceStatusSummary: {},
      sourceStatusLastARI: null,
      sourceStatusLoading: false,
      sourceStatusQueried: false,
      sourceStatusQuery: { room_type_code: '', product_code: '', stay_date: '', page: 1, limit: 20 },
      refreshTimer: null,
      listRequestId: 0,
      diagnosticRequestId: 0,
      diagnosticSnapshotRequestId: 0,
      rateMappingRequestId: 0,
      sourceStatusRequestId: 0,
    }
  },
  created() {
    this.getList()
    this.refreshTimer = setInterval(() => {
      if (document.hidden) return
      if (this.taskDialogVisible) this.getTasks(false)
      else if (!this.diagnosticVisible && !this.batchVisible && !this.taskFlowVisible) this.getList(false)
    }, 10000)
  },
  beforeDestroy() {
    if (this.refreshTimer) clearInterval(this.refreshTimer)
    this.listRequestId += 1
    this.diagnosticRequestId += 1
    this.diagnosticSnapshotRequestId += 1
    this.rateMappingRequestId += 1
    this.sourceStatusRequestId += 1
  },
  methods: {
    getList(showLoading = true) {
      const requestId = ++this.listRequestId
      if (showLoading) this.listLoading = true
      this.listError = ''
      return request({
        url: '/api/backend/dida/hotel-publish-controls',
        method: 'get',
        params: { ...this.listQuery },
      })
        .then((response) => {
          if (requestId !== this.listRequestId) return
          this.list = response.data.items
          this.total = response.data.total
          this.lastRefreshedAt = new Date().toLocaleString()
        })
        .catch(() => {
          if (requestId === this.listRequestId) this.listError = '资源发布控制数据读取失败'
        })
        .finally(() => { if (requestId === this.listRequestId) this.listLoading = false })
    },
    getTasks(showLoading = true) {
      if (showLoading) this.taskLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-tasks',
        method: 'get',
        params: this.taskQuery,
      })
        .then((response) => {
          this.tasks = response.data.items
          this.taskTotal = response.data.total
        })
        .finally(() => { this.taskLoading = false })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetFilter() {
      this.listQuery = {
        page: 1,
        limit: this.listQuery.limit,
        supplier: '',
        ari_sort: 'desc',
        ari_health: '',
        rate_category: '',
        rate_publish_status: '',
        source_hotel_code: '',
        dida_hotel_code: '',
        hotel_name: '',
        desired_status: '',
        bulk_operation_locked: '',
        source_status: '',
        foreign_guest_status: '',
        supplier_gate_status: '',
        last_published_status: '',
        last_task_status: '',
        has_error: '',
      }
      this.getList()
    },
    handleSizeChange(value) {
      this.listQuery.limit = value
      this.getList()
    },
    handleCurrentChange(value) {
      this.listQuery.page = value
      this.getList()
    },
    handleTaskPage(value) {
      this.taskQuery.page = value
      this.getTasks()
    },
    resetTaskFilter() {
      this.taskQuery = { page: 1, limit: this.taskQuery.limit, supplier: '', status: '', resource_type: '', hotel_code: '' }
      this.getTasks()
    },
    openTasks() {
      this.taskDialogVisible = true
    },
    changeStatus(row, status) {
      if (status === 0) {
        this.$prompt('请输入下架原因', '确认下架并同步Dida', {
          confirmButtonText: '确认下架',
          cancelButtonText: '取消',
          inputValue: '后台手动下架',
          inputValidator: (value) => !!(value && value.trim()),
          inputErrorMessage: '请输入下架原因',
        }).then(({ value }) => this.submitStatus(row, status, value)).catch(() => {})
        return
      }
      this.$confirm('确认将该酒店设为上架并立即提交Dida同步任务？', '确认上架', { type: 'warning' })
        .then(() => this.submitStatus(row, status, ''))
        .catch(() => {})
    },
    submitStatus(row, status, reason) {
      this.rowActionKey = this.rowKey(row)
      return request({
        url: '/api/backend/dida/hotel-publish-controls/change-status',
        method: 'post',
        data: {
          supplier: row.supplier,
          source_hotel_code: row.source_hotel_code,
          desired_status: status,
          offline_reason: reason,
          sync_now: true,
        },
      }).then((response) => {
        this.$message.success(response.msg || '任务已提交')
        this.getList()
      }).finally(() => { this.rowActionKey = '' })
    },
    changeLock(row) {
      const locked = Number(row.bulk_operation_locked) !== 1
      const action = locked ? '锁定一键操作' : '取消一键保护'
      this.$confirm(
        locked
          ? '锁定后，一键上架/下架会跳过该酒店；单酒店上下架和紧急总开关仍可生效。'
          : '取消保护后，后续一键上架/下架将会修改该酒店状态。',
        action,
        { type: 'warning' },
      ).then(() => {
        this.rowActionKey = this.rowKey(row)
        return request({
          url: '/api/backend/dida/hotel-publish-controls/change-lock',
          method: 'post',
          data: {
            supplier: row.supplier,
            source_hotel_code: row.source_hotel_code,
            locked: locked ? 1 : 0,
            reason: '后台手动' + action,
          },
        })
      }).then((response) => {
        this.$message.success(response.msg || '锁定状态已更新')
        this.getList(false)
        if (this.fullSupplier !== 'all') this.loadSupplierSummary()
      }).catch(() => {})
        .finally(() => { this.rowActionKey = '' })
    },
    syncHotel(row) {
      this.$confirm('确认按当前目标状态重新推送该酒店的静态资源和ARI？', '手动同步', { type: 'warning' })
        .then(() => {
          this.rowActionKey = this.rowKey(row)
          return request({
            url: '/api/backend/dida/hotel-publish-controls/sync-hotel',
            method: 'post',
            data: { supplier: row.supplier, source_hotel_code: row.source_hotel_code },
          })
        })
        .then((response) => {
          this.$message.success(response.msg || '任务已提交')
          this.getList()
        })
        .catch(() => {})
        .finally(() => { this.rowActionKey = '' })
    },
    syncHotelDifferential(row, resourceType) {
      if (!['static', 'ari'].includes(resourceType)) return Promise.resolve()
      const typeName = resourceType === 'static' ? '静态资源' : 'ARI'
      return this.$confirm(`确认对 ${this.supplierName(row.supplier)}/${row.source_hotel_code} 执行${typeName}差异更新？未变化资源不会请求Dida。`, `单酒店${typeName}差异更新`, { type: 'warning' })
        .then(() => {
          this.rowActionKey = this.rowKey(row)
          return request({
            url: '/api/backend/dida/hotel-publish-controls/sync-hotel-differential',
            method: 'post',
            data: {
              supplier: row.supplier,
              source_hotel_code: row.source_hotel_code,
              resource_type: resourceType,
            },
          })
        })
        .then((response) => {
          this.$message.success(response.msg || `单酒店${typeName}差异更新任务已提交`)
          this.taskDialogVisible = true
          this.getTasks(false)
        })
        .catch(() => {})
        .finally(() => { this.rowActionKey = '' })
    },
    syncAll() {
      const scope = this.fullSupplier === 'all' ? '全部资源类型' : this.supplierName(this.fullSupplier)
      this.$confirm(`确认提交“${scope}”全量同步？任务将按当前控制状态推送静态资源和ARI。`, '全量同步', { type: 'warning' })
        .then(() => {
          this.fullSyncLoading = true
          return request({
            url: '/api/backend/dida/hotel-publish-controls/sync-all',
            method: 'post',
            data: { supplier: this.fullSupplier },
          })
        })
        .then((response) => {
          this.$message.success(response.msg || '全量任务已提交')
          this.taskDialogVisible = true
        })
        .catch(() => {})
        .finally(() => { this.fullSyncLoading = false })
    },
    syncDifferential(resourceType) {
      if (!['static', 'ari'].includes(resourceType)) return
      const scope = this.fullSupplier === 'all' ? '全部资源类型' : this.supplierName(this.fullSupplier)
      const typeName = resourceType === 'static' ? '静态资源' : 'ARI'
      return this.$confirm(`确认提交“${scope}”${typeName}差异更新？未变化酒店不会请求Dida。`, `${typeName}差异更新`, { type: 'warning' })
        .then(() => {
          this.diffSyncLoading = true
          return request({
            url: '/api/backend/dida/hotel-publish-controls/sync-differential',
            method: 'post',
            data: { supplier: this.fullSupplier, resource_type: resourceType },
          })
        })
        .then((response) => {
          this.$message.success(response.msg || `${typeName}差异更新任务已提交`)
          this.taskDialogVisible = true
          this.getTasks(false)
        })
        .catch(() => {})
        .finally(() => { this.diffSyncLoading = false })
    },
    changeAllStatus(status) {
      const scope = this.fullSupplier === 'all' ? '全部资源类型' : this.supplierName(this.fullSupplier)
      const submit = (reason) => {
        this.bulkStatusLoading = true
        return request({
          url: '/api/backend/dida/hotel-publish-controls/change-all-status',
          method: 'post',
          data: { supplier: this.fullSupplier, desired_status: status, reason },
        })
      }
      const confirmation = status === 0
        ? this.$prompt(`确认一键下架“${scope}”内全部未锁定酒店？请输入原因：`, '一键下架', {
          confirmButtonText: '确认下架并同步',
          cancelButtonText: '取消',
          inputValue: '财务尚未上线',
          inputValidator: (value) => !!(value && value.trim()),
          inputErrorMessage: '必须填写下架原因',
        }).then(({ value }) => value)
        : this.$confirm(`确认一键上架“${scope}”内全部未锁定酒店并同步Dida？`, '一键上架', {
          confirmButtonText: '确认上架并同步', cancelButtonText: '取消', type: 'warning',
        }).then(() => '')
      confirmation.then(submit).then((response) => {
        const data = response.data || {}
        this.$message.success(`${response.msg || '批量任务已提交'}；已修改${data.changed_count || 0}家，跳过锁定${data.skipped_locked_count || 0}家`)
        this.taskDialogVisible = !!data.queued
        this.getList(false)
        if (this.fullSupplier !== 'all') this.loadSupplierSummary()
      }).catch(() => {})
        .finally(() => { this.bulkStatusLoading = false })
    },
    enrollNew() {
      if (this.fullSupplier === 'all') {
        this.$message.warning('请先选择一个具体资源类型')
        return
      }
      this.enrollInitialStatus = 0
      this.enrollReason = '首批酒店先推送匹配'
      this.enrollDialogVisible = true
    },
    submitEnrollNew() {
      this.newEnrollLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-controls/enroll-new',
        method: 'post',
        data: {
          supplier: this.fullSupplier,
          initial_status: this.enrollInitialStatus,
          reason: this.enrollReason,
        },
      })
        .then((response) => {
          this.$message.success(response.msg || '新房源纳入任务已提交')
          this.enrollDialogVisible = false
          this.taskDialogVisible = true
          this.getTasks(false)
        })
        .finally(() => { this.newEnrollLoading = false })
    },
    handleSupplierChange() {
      this.supplierSummary = null
      if (this.fullSupplier !== 'all') this.loadSupplierSummary()
    },
    loadSupplierSummary() {
      if (this.fullSupplier === 'all') return Promise.resolve(null)
      return request({
        url: '/api/backend/dida/supplier-publish-control/summary',
        method: 'get',
        params: { supplier: this.fullSupplier },
      }).then((response) => {
        this.supplierSummary = response.data
        return response.data
      })
    },
    changeSupplierStatus(status) {
      if (this.fullSupplier === 'all') {
        this.$message.warning('请先选择一个具体资源类型')
        return
      }
      this.supplierGateLoading = true
      this.loadSupplierSummary()
        .then((summary) => {
          const scope = this.supplierName(this.fullSupplier)
          const impact = `当前单酒店启用 ${summary.hotel_enabled_total}/${summary.hotel_total}，历史已发布 ${summary.published_total} 家。`
          if (status === 0) {
            return this.$prompt(`${impact} 关闭后会立即创建全量下架任务，但不会改变单酒店白名单。请输入原因：`, `关闭${scope}`, {
              confirmButtonText: '确认关闭并同步',
              cancelButtonText: '取消',
              inputValidator: (value) => !!(value && value.trim()),
              inputErrorMessage: '必须填写关闭原因',
            }).then(({ value }) => value)
          }
          return this.$confirm(`${impact} 恢复后只会重新开放原本已启用的单酒店，不会开放异常测试酒店。`, `恢复${scope}`, {
            confirmButtonText: '确认恢复并同步',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => '')
        })
        .then((reason) => request({
          url: '/api/backend/dida/supplier-publish-control/change-status',
          method: 'post',
          data: {
            supplier: this.fullSupplier,
            desired_status: status,
            reason,
          },
        }))
        .then((response) => {
          this.$message.success(response.msg || '供应商状态任务已提交')
          this.taskDialogVisible = true
          this.loadSupplierSummary()
          this.getList(false)
        })
        .catch(() => {})
        .finally(() => { this.supplierGateLoading = false })
    },
    supplierName(value) {
      const item = this.suppliers.find((supplier) => supplier.value === value)
      return item ? item.label : value
    },
    supplierTag(value) {
      const tags = { jin_jiang: '', long_teng: 'warning', sui_chuan: 'danger', li_cheng: 'success' }
      return tags[value] !== undefined ? tags[value] : 'info'
    },
    ratePlanTotalCount(row, category) {
      const summary = row && row.rate_plan_summary
      return Number((summary && summary[category] && summary[category].total) || 0)
    },
    ratePlanSuccessCount(row, category) {
      const summary = row && row.rate_plan_summary
      return Number((summary && summary[category] && summary[category].success) || 0)
    },
    isSourceBookable(row) {
      return Number(row.is_on) === 1 && Number(row.valid) === 1 && Number(row.status) === 1 && Number(row.book_flag) === 1
    },
    foreignGuestSupportName(value) {
      if (value === null || value === undefined || value === '') return '未知'
      return Number(value) === 1 ? '支持' : (Number(value) === 0 ? '不支持' : '未知')
    },
    foreignGuestSupportTag(value) {
      if (value === null || value === undefined || value === '') return 'warning'
      return Number(value) === 1 ? 'success' : (Number(value) === 0 ? 'danger' : 'warning')
    },
    rowKey(row) {
      return `${row.supplier}:${row.source_hotel_code}`
    },
    isHotelDesiredUp(row) {
      if (Number(row.publish_enabled) !== 1 || Number(row.desired_status) !== 1) return false
      if (!row.temporary_offline_until) return true
      const offlineUntil = new Date(String(row.temporary_offline_until).replace(/-/g, '/'))
      return Number.isNaN(offlineUntil.getTime()) || offlineUntil.getTime() <= Date.now()
    },
    isSupplierGateUp(row) {
      if (row.supplier_publish_enabled !== null && Number(row.supplier_publish_enabled) !== 1) return false
      if (row.supplier_desired_status !== null && Number(row.supplier_desired_status) !== 1) return false
      if (!row.supplier_temporary_offline_until) return true
      const offlineUntil = new Date(String(row.supplier_temporary_offline_until).replace(/-/g, '/'))
      return Number.isNaN(offlineUntil.getTime()) || offlineUntil.getTime() <= Date.now()
    },
    isTargetUp(row) {
      return this.isHotelDesiredUp(row) && this.isSupplierGateUp(row)
    },
    showTaskFlow(row) {
      this.selectedTask = row
      this.taskFlowVisible = true
    },
    taskStepActive(task) {
      if (!task || task.status === 'PENDING') return 1
      if (task.status === 'PROCESSING' || task.status === 'RETRY') return 2
      return 3
    },
    taskExecutionText(task) {
      if (task.status === 'RETRY') return `等待第 ${Number(task.retry_count) + 1} 次执行`
      if (task.status === 'PROCESSING' && ['manual_static', 'manual_static_hotel'].includes(task.resource_type)) return '正在比较并更新静态资源差异'
      if (task.status === 'PROCESSING' && ['manual_ari', 'manual_ari_hotel'].includes(task.resource_type)) return '正在比较并更新ARI差异'
      if (task.status === 'PROCESSING') return '正在推送静态资源和ARI'
      if (task.status === 'CANCEL_REQUESTED') return '已收到中断请求，等待当前步骤安全结束'
      if (task.status === 'CANCELLED') return '任务已中断，未继续执行后续范围'
      return task.updated_at || '-'
    },
    taskTraceId(task) {
      return task ? `dida-manual-${task.id}` : '-'
    },
    retryTask(row) {
      if (row.resource_type === 'manual_enroll') {
        this.$prompt('请重新指定本次纳入任务的初始 Status（0 或 1），不会沿用旧任务要求。', '重试新房源纳入任务', {
          type: 'warning',
          inputValue: '0',
          inputPattern: /^[01]$/,
          inputErrorMessage: '只能填写 0 或 1',
          confirmButtonText: '创建新任务',
        })
          .then(({ value }) => request({
            url: '/api/backend/dida/hotel-publish-tasks/retry',
            method: 'post',
            data: { task_id: row.id, initial_status: Number(value) },
          }))
          .then((response) => {
            this.$message.success(response.msg || '重试任务已提交')
            this.getTasks(false)
          })
          .catch(() => {})
        return
      }
      this.$confirm(`确认重试任务 #${row.id}？将创建新任务并保留原任务记录。`, '手动重试', { type: 'warning' })
        .then(() => request({
          url: '/api/backend/dida/hotel-publish-tasks/retry',
          method: 'post',
          data: { task_id: row.id },
        }))
        .then((response) => {
          this.$message.success(response.msg || '重试任务已提交')
          this.getTasks(false)
          if (this.diagnosticVisible && this.diagnostic && this.diagnostic.control) {
            this.diagnose(this.diagnostic.control, false)
          }
        })
        .catch(() => {})
    },
    cancelTask(row) {
      this.$prompt('可填写中断原因，留空使用默认原因。处理中任务会先进入“中断中”，当前酒店步骤结束后安全停止。', '中断手动同步任务', {
        type: 'warning',
        inputPlaceholder: '例如：本次范围有误，需要重新选择后再试',
        confirmButtonText: '确认中断',
        cancelButtonText: '取消',
      })
        .then(({ value }) => request({
          url: '/api/backend/dida/hotel-publish-tasks/cancel',
          method: 'post',
          data: { task_id: row.id, reason: String(value || '').trim() },
        }))
        .then((response) => {
          this.$message.success(response.msg || '中断请求已提交')
          this.getTasks(false)
          if (this.batchVisible && this.batchTask && this.batchTask.id === row.id) {
            this.getBatchItems()
          }
          if (this.diagnosticVisible && this.diagnostic && this.diagnostic.control) {
            this.diagnose(this.diagnostic.control, false)
          }
        })
        .catch(() => {})
    },
    diagnose(row, openDialog = true) {
      const requestId = ++this.diagnosticRequestId
      if (openDialog) {
        this.diagnosticSnapshotRequestId += 1
        this.rateMappingRequestId += 1
        this.sourceStatusRequestId += 1
        this.diagnosticSnapshotLoading = false
        this.sourceStatusLoading = false
        this.diagnosticVisible = true
        this.diagnosticSnapshots = []
        this.diagnosticSnapshotTotal = 0
        this.rateMappings = []
        this.rateMappingTotal = 0
        this.sourceStatuses = []
        this.sourceStatusTotal = 0
        this.sourceStatusSummary = {}
        this.sourceStatusLastARI = null
        this.sourceStatusQueried = false
        this.diagnosticSnapshotQuery = { kind: 'hotel', publish_status: '', resource_code: '', source_room_type_code: '', source_product_code: '', stay_date: '', page: 1, limit: 20 }
        this.rateMappingQuery = { rate_category: '', active: 1, meal_count: '', source_room_type_code: '', source_product_code: '', dida_code: '', page: 1, limit: 20 }
        this.sourceStatusQuery = { room_type_code: '', product_code: '', stay_date: '', page: 1, limit: 20 }
      }
      this.diagnosticLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-controls/diagnostics',
        method: 'get',
        params: { supplier: row.supplier, source_hotel_code: row.source_hotel_code },
      })
        .then((response) => {
          if (requestId !== this.diagnosticRequestId) return
          this.diagnostic = response.data
          return Promise.all([this.getDiagnosticSnapshots(), this.getRatePlanMappings(), this.getSourceStatuses()])
        })
        .finally(() => { if (requestId === this.diagnosticRequestId) this.diagnosticLoading = false })
    },
    showBatchItems(row) {
      this.batchTask = row
      this.batchItems = []
      this.batchTotal = 0
      this.batchSummary = {}
      this.batchSelection = []
      this.batchQuery = { status: '', supplier: '', hotel_code: '', page: 1, limit: 20 }
      this.batchVisible = true
      this.getBatchItems()
    },
    getBatchItems() {
      if (!this.batchTask) return Promise.resolve()
      this.batchLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-tasks/batch-items',
        method: 'get',
        params: { task_id: this.batchTask.id, ...this.batchQuery },
      }).then((response) => {
        this.batchItems = response.data.items || []
        this.batchTotal = response.data.total || 0
        this.batchSummary = response.data.summary || {}
        this.batchTask = { ...this.batchTask, ...(response.data.task || {}) }
      }).finally(() => { this.batchLoading = false })
    },
    handleBatchFilter() {
      this.batchQuery.page = 1
      this.getBatchItems()
    },
    handleBatchSize(value) {
      this.batchQuery.limit = value
      this.batchQuery.page = 1
      this.getBatchItems()
    },
    handleBatchPage(value) {
      this.batchQuery.page = value
      this.getBatchItems()
    },
    handleBatchSelection(rows) {
      this.batchSelection = rows
    },
    batchItemSelectable(row) {
      return !!(this.batchTask && this.batchTask.status === 'FAILED' && row.status === 'FAILED')
    },
    retrySelectedBatchItems() {
      if (!this.batchTask || !this.batchSelection.length) return
      const itemIds = this.batchSelection.map((item) => item.id)
      this.$confirm(`确认将所选 ${itemIds.length} 家失败酒店分别创建单酒店重推任务？原批次结果会保留。`, '批量重推失败酒店', { type: 'warning' })
        .then(() => request({
          url: '/api/backend/dida/hotel-publish-tasks/retry-batch-items',
          method: 'post',
          data: { task_id: this.batchTask.id, item_ids: itemIds },
        }))
        .then((response) => {
          this.$message.success(response.msg || '失败酒店重推任务已提交')
          this.batchSelection = []
          this.getTasks(false)
          this.getBatchItems()
        })
        .catch(() => {})
    },
    retryBatchHotel(row) {
      const action = row.status === 'FAILED' ? '单独重推失败酒店' : '再次推送该酒店'
      this.$confirm(`确认${action} ${this.supplierName(row.supplier)}/${row.hotel_code}？该操作会创建独立的单酒店任务，不会改动本批次历史结果。`, action, { type: 'warning' })
        .then(() => request({
          url: '/api/backend/dida/hotel-publish-controls/sync-hotel',
          method: 'post',
          data: { supplier: row.supplier, source_hotel_code: row.hotel_code },
        }))
        .then((response) => {
          this.$message.success(response.msg || '单酒店任务已提交')
          this.getTasks(false)
        })
        .catch(() => {})
    },
    getDiagnosticSnapshots() {
      if (!this.diagnostic || !this.diagnostic.control) return Promise.resolve()
      const requestId = ++this.diagnosticSnapshotRequestId
      this.diagnosticSnapshotLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-controls/snapshots',
        method: 'get',
        params: {
          supplier: this.diagnostic.control.supplier,
          source_hotel_code: this.diagnostic.control.source_hotel_code,
          ...this.diagnosticSnapshotQuery,
        },
      }).then((response) => {
        if (requestId !== this.diagnosticSnapshotRequestId) return
        this.diagnosticSnapshots = response.data.items || []
        this.diagnosticSnapshotTotal = response.data.total || 0
      }).finally(() => { if (requestId === this.diagnosticSnapshotRequestId) this.diagnosticSnapshotLoading = false })
    },
    getRatePlanMappings() {
      if (!this.diagnostic || !this.diagnostic.control) return Promise.resolve()
      const requestId = ++this.rateMappingRequestId
      this.rateMappingLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-controls/rate-plan-mappings',
        method: 'get',
        params: {
          supplier: this.diagnostic.control.supplier,
          source_hotel_code: this.diagnostic.control.source_hotel_code,
          ...this.rateMappingQuery,
        },
      }).then((response) => {
        if (requestId !== this.rateMappingRequestId) return
        this.rateMappings = response.data.items || []
        this.rateMappingTotal = response.data.total || 0
      }).finally(() => { if (requestId === this.rateMappingRequestId) this.rateMappingLoading = false })
    },
    handleRateMappingFilter() {
      this.rateMappingQuery.page = 1
      this.getRatePlanMappings()
    },
    handleRateMappingSizeChange(value) {
      this.rateMappingQuery.limit = value
      this.rateMappingQuery.page = 1
      this.getRatePlanMappings()
    },
    handleRateMappingPageChange(value) {
      this.rateMappingQuery.page = value
      this.getRatePlanMappings()
    },
    resetRateMappingFilters() {
      this.rateMappingQuery = { rate_category: '', active: 1, meal_count: '', source_room_type_code: '', source_product_code: '', dida_code: '', page: 1, limit: 20 }
      this.getRatePlanMappings()
    },
    handleSnapshotKindChange() {
      const kind = this.diagnosticSnapshotQuery.kind
      const limit = this.diagnosticSnapshotQuery.limit
      this.diagnosticSnapshotQuery = {
        kind,
        publish_status: '',
        resource_code: '',
        source_room_type_code: '',
        source_product_code: '',
        stay_date: '',
        page: 1,
        limit,
      }
      this.getDiagnosticSnapshots()
    },
    handleSnapshotFilter() {
      this.diagnosticSnapshotQuery.page = 1
      this.getDiagnosticSnapshots()
    },
    handleSnapshotSizeChange(value) {
      this.diagnosticSnapshotQuery.limit = value
      this.diagnosticSnapshotQuery.page = 1
      this.getDiagnosticSnapshots()
    },
    handleSnapshotPageChange(value) {
      this.diagnosticSnapshotQuery.page = value
      this.getDiagnosticSnapshots()
    },
    resetSnapshotFilters() {
      const kind = this.diagnosticSnapshotQuery.kind
      this.diagnosticSnapshotQuery = { kind, publish_status: '', resource_code: '', source_room_type_code: '', source_product_code: '', stay_date: '', page: 1, limit: 20 }
      this.getDiagnosticSnapshots()
    },
    getSourceStatuses() {
      if (!this.diagnostic || !this.diagnostic.control) return Promise.resolve()
      const requestId = ++this.sourceStatusRequestId
      if (!this.sourceStatusQuery.stay_date && !this.sourceStatusQuery.room_type_code.trim() && !this.sourceStatusQuery.product_code.trim()) {
        this.sourceStatuses = []
        this.sourceStatusTotal = 0
        this.sourceStatusSummary = {}
        this.sourceStatusQueried = false
        this.sourceStatusLoading = false
        return Promise.resolve()
      }
      this.sourceStatusLoading = true
      return request({
        url: '/api/backend/dida/hotel-publish-controls/source-statuses',
        method: 'get',
        params: {
          supplier: this.diagnostic.control.supplier,
          source_hotel_code: this.diagnostic.control.source_hotel_code,
          ...this.sourceStatusQuery,
        },
      }).then((response) => {
        if (requestId !== this.sourceStatusRequestId) return
        this.sourceStatuses = response.data.items || []
        this.sourceStatusTotal = response.data.total || 0
        this.sourceStatusSummary = response.data.page_summary || {}
        this.sourceStatusLastARI = response.data.last_ari_success_at || null
        this.sourceStatusQueried = true
      }).finally(() => { if (requestId === this.sourceStatusRequestId) this.sourceStatusLoading = false })
    },
    handleSourceStatusFilter() {
      if (!this.sourceStatusQuery.stay_date && !this.sourceStatusQuery.room_type_code.trim() && !this.sourceStatusQuery.product_code.trim()) {
        this.getSourceStatuses()
        this.$message.warning('请先指定入住日期或源房型、产品编码')
        return
      }
      this.sourceStatusQuery.page = 1
      this.getSourceStatuses()
    },
    handleSourceStatusSizeChange(value) {
      this.sourceStatusQuery.limit = value
      this.sourceStatusQuery.page = 1
      this.getSourceStatuses()
    },
    handleSourceStatusPageChange(value) {
      this.sourceStatusQuery.page = value
      this.getSourceStatuses()
    },
    resetSourceStatusFilters() {
      this.sourceStatusRequestId += 1
      this.sourceStatusQuery = { room_type_code: '', product_code: '', stay_date: '', page: 1, limit: 20 }
      this.sourceStatuses = []
      this.sourceStatusTotal = 0
      this.sourceStatusSummary = {}
      this.sourceStatusLastARI = null
      this.sourceStatusLoading = false
      this.sourceStatusQueried = false
    },
    sourceStatusName(value) {
      return { accepted: '有Status=1快照', inactive: '有Status=0快照', excluded: '同步后无快照', pending: '待同步/待确认' }[value] || '-'
    },
    sourceStatusTag(value) {
      return { accepted: 'success', inactive: 'warning', excluded: 'danger', pending: 'info' }[value] || 'info'
    },
    prettyJSON(value) {
      if (value === null || value === undefined || value === '') return '-'
      if (typeof value === 'string') {
        try { return JSON.stringify(JSON.parse(value), null, 2) } catch (error) { return value }
      }
      return JSON.stringify(value, null, 2)
    },
    booleanName(value) {
      if (value === true || value === 1 || value === '1') return '是'
      if (value === false || value === 0 || value === '0') return '否'
      return '-'
    },
    snapshotIdentity(row) {
      const kind = this.diagnosticSnapshotQuery.kind
      if (kind === 'hotel') return `平台:${this.diagnostic.control.source_hotel_code} → Dida:${row.resource_code || '-'}`
      if (kind === 'room') return `平台:${row.source_room_type_code || '-'} → Dida:${row.resource_code || '-'}`
      if (kind === 'rate_plan') return `平台:${row.source_product_code || '-'} → Dida:${row.resource_code || '-'}`
      if (kind === 'inventory') return `平台:${row.source_room_type_code || '-'} → Dida:${row.room_type_code || '-'}`
      return `平台:${row.source_product_code || '-'} → Dida:${row.rate_plan_code || '-'}`
    },
    comparisonSideSummary(row, side) {
      const labels = {
        hotel: ['酒店中文名', '发布状态', '币种', '邮箱'],
        room: ['房型中文名', '最大入住人数', '床型', '窗型'],
        rate_plan: ['产品名称', '基础入住人数', '早餐份数', '可取消及罚则'],
        inventory: ['房量', '开关状态'],
        rate: ['价格', '币种', '可售状态', '早餐'],
      }[this.diagnosticSnapshotQuery.kind] || []
      const fields = row.comparison_fields || []
      return labels.map((label) => fields.find((field) => field.label === label)).filter(Boolean)
        .map((field) => `${field.label}:${side === 'source' ? field.source_value : field.dida_value}`).join('；') || '-'
    },
    summaryCount(row, name) {
      return Number((row.comparison_summary || {})[name] || 0)
    },
    comparisonResultName(result) {
      return { same: '一致', different: '直接差异', mapped: '规则转换', fixed: '固定值', not_pushed: '未推送' }[result] || result || '-'
    },
    comparisonTagType(result) {
      return { same: 'success', different: 'danger', mapped: 'warning', fixed: '', not_pushed: 'info' }[result] || 'info'
    },
    snapshotStateTag(state) {
      return { synchronized: 'success', source_newer: 'warning', different: 'danger', source_missing: 'danger' }[state] || 'info'
    },
    failureReason(value) {
      const error = String(value || '').trim()
      if (!error) return '-'
      if (error.includes('DIDA_BUSINESS_REJECTED_NO_MESSAGE')) {
        return `${error}（道旅返回了拒绝业务码，但未提供具体message，需携带Trace ID请道旅排查）`
      }
      if (/dida API failed:\s*code=0\s*message=\s*$/i.test(error)) {
        return `DIDA_BUSINESS_REJECTED_NO_MESSAGE（历史记录）｜${error}｜道旅返回业务码0且message为空，需携带Trace ID请道旅排查`
      }
      return error
    },
    snapshotValue(name) {
      if (!this.diagnostic || !this.diagnostic.snapshot_counts) return 0
      return this.diagnostic.snapshot_counts[name] || 0
    },
    rateSummary(category, field) {
      const summary = this.diagnostic && this.diagnostic.rate_plan_summary
      return Number((summary && summary[category] && summary[category][field]) || 0)
    },
    rateCategoryName(category) {
      return { protocol: '协议价', activity: '活动价', unclassified: '待分类' }[category] || '待分类'
    },
    rateCategoryTag(category) {
      return { protocol: 'success', activity: 'warning', unclassified: 'info' }[category] || 'info'
    },
    mealCountName(value) {
      if (value === null || value === undefined || value === '') return '早餐字段缺失'
      const count = Number(value)
      if (count === 0) return '无早（0份）'
      if (count === 1) return '单早（1份）'
      if (count === 2) return '双早（2份）'
      return `${count}份早餐`
    },
    nationalityRuleName(row) {
      if (row.area_option_type === null || row.area_option_type === undefined) return '国籍字段缺失'
      const type = Number(row.area_option_type)
      const countries = Array.isArray(row.country_code_list) ? row.country_code_list.join('、') : ''
      if (type === 0) return '不限国籍'
      if (type === 1) return `仅限：${countries || '国家列表缺失'}`
      if (type === 2) return `排除：${countries || '国家列表缺失'}`
      return `未知类型：${row.area_option_type}`
    },
    taskStatusName(status) {
      return { PENDING: '待执行', PROCESSING: '执行中', RETRY: '待重试', CANCEL_REQUESTED: '中断中', SUCCESS: '推送已受理', FAILED: '失败', CANCELLED: '已中断' }[status] || status || '-'
    },
    taskTagType(status) {
      return { PENDING: 'info', PROCESSING: 'warning', RETRY: 'warning', CANCEL_REQUESTED: 'warning', SUCCESS: 'success', FAILED: 'danger', CANCELLED: 'info' }[status] || 'info'
    },
    taskTypeName(resourceType) {
      return { manual_hotel: '单酒店', manual_full: '全量', manual_enroll: '新房源纳入', manual_static: '静态资源差异', manual_ari: 'ARI差异', manual_static_hotel: '单酒店静态差异', manual_ari_hotel: '单酒店ARI差异' }[resourceType] || resourceType || '-'
    },
    isBatchTask(task) {
      return task && ['manual_full', 'manual_enroll', 'manual_static', 'manual_ari'].includes(task.resource_type)
    },
    batchTaskTitle(task) {
      return {
        manual_enroll: '新房源纳入批次详情',
        manual_static: '静态资源差异更新批次详情',
        manual_ari: 'ARI差异更新批次详情',
      }[(task && task.resource_type) || ''] || '全量推送批次详情'
    },
    operationActionName(action) {
      return {
        hotel_enable: '酒店上架',
        hotel_disable: '酒店下架',
        hotel_sync: '酒店同步',
        full_sync: '全量同步',
        diff_static_sync: '静态资源差异更新',
        diff_ari_sync: 'ARI差异更新',
        hotel_diff_static_sync: '单酒店静态差异更新',
        hotel_diff_ari_sync: '单酒店ARI差异更新',
        enroll_new: '纳入新房源并立即推送',
        supplier_disable: '资源类型关闭',
        supplier_restore: '资源类型恢复',
        task_retry: '失败重试',
        task_cancel: '中断任务',
        batch_item_retry: '批次失败酒店重推',
        bulk_lock: '锁定一键操作',
        bulk_unlock: '取消一键保护',
        bulk_enable: '一键上架',
        bulk_disable: '一键下架',
      }[action] || action || '-'
    },
  },
}
</script>

<style scoped>
.sync-toolbar {
  padding: 12px;
  margin-bottom: 14px;
  background: #fff8e8;
  border: 1px solid #f5dab1;
  border-radius: 4px;
}
.sync-toolbar-main,
.sync-toolbar-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.sync-toolbar-meta {
  justify-content: space-between;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px dashed #e6c98f;
}
.sync-title { min-width: 96px; font-weight: 600; }
.supplier-selector { width: 180px; }
.supplier-actions .el-button { min-width: 108px; }
.sync-tip { color: #8c6d1f; font-size: 12px; }
.row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}
.main-row-actions {
  flex-wrap: wrap;
  white-space: normal;
}
.row-actions .el-button { margin-left: 0; }
.operation-help-icon {
  margin-left: 4px;
  color: #409eff;
  cursor: pointer;
}
.task-help { margin-bottom: 12px; }
.batch-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  margin: 14px 0 10px;
}
.task-detail {
  margin-top: 24px;
  padding: 12px;
  background: #f7f8fa;
}
.diagnostic-cards { margin: 16px 0; text-align: center; }
.diagnostic-cards .metric {
  margin-bottom: 8px;
  color: #409eff;
  font-size: 20px;
  font-weight: 600;
}
.diagnostic-error { margin-top: 12px; }
.rate-summary-cards { margin: 0 0 16px; text-align: center; }
.rate-summary-cards .el-card { min-height: 126px; }
.rate-summary-cards .rate-summary-title { color: #606266; font-size: 13px; }
.rate-summary-cards strong { display: inline-block; margin: 10px 5px 5px 0; color: #2f86c7; font-size: 25px; }
.rate-summary-cards span { color: #606266; font-size: 12px; }
.rate-summary-cards small { display: block; color: #909399; }
.rate-summary-cards .is-unclassified { border-color: #e6a23c; }
.snapshot-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.snapshot-tip { color: #909399; font-size: 12px; }
.rate-plan-meta { margin-top: 5px; color: #606266; font-size: 12px; }
.source-query-hint { padding: 18px; color: #909399; text-align: center; border: 1px dashed #dcdfe6; }
.comparison-detail-title {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 0 10px;
  color: #606266;
}
.comparison-detail-title span { color: #909399; font-size: 12px; }
.comparison-table { margin-bottom: 8px; }
.rule-comparison { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 12px; margin-bottom: 12px; }
.rule-comparison > div { min-width: 0; }
.rule-comparison pre { overflow: auto; max-height: 250px; padding: 10px; background: #f7f8fa; white-space: pre-wrap; word-break: break-all; }
.comparison-tags {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  justify-content: center;
}
.snapshot-pagination { margin: 12px 0 18px; text-align: right; }
.activity-link { color: #2f86c7; font-weight: 600; text-decoration: none; }
.activity-link:hover { text-decoration: underline; }
.operation-help p {
  margin: 6px 0;
  line-height: 1.5;
}
.help-button { padding: 0; }
</style>
